import { defineStore } from 'pinia'
import { defaultState, defaultActions } from './_global'

export const usePagesStore = defineStore('pagesStore', {
  state: () => ({
    endpoint: 'pages',
    ...defaultState
  }),
  actions: {
    ...defaultActions
  }
})
